import React from 'react';
import styles from './billing-month-filter.module.scss'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from 'dayjs';
import { formatReportDate } from '../../../../common/Utils/CommonFunctions/CommonFunctions';
import { commonConstants } from '../../../../common/constants';

const MonthFilter = ({ selectedDate, setSelectedDate, handleChangePatientsFilter, validDate, setValidDate }) => {
    const currentDate = dayjs();
    const threeYearsAgo = currentDate.subtract(3, 'year');

    const handleDateChange = (newValue) => {
        if (newValue) {
            if (newValue.toLocaleString() === commonConstants.invalidDate || newValue?.$y < commonConstants.minValidDate || newValue?.$y >= commonConstants.maxValidDate || newValue?.$y < threeYearsAgo.year() || newValue?.$y > currentDate.year() || (newValue?.$y === currentDate.year() && newValue?.$M > currentDate.month()) || (newValue?.$y === threeYearsAgo.year() && newValue?.$M < currentDate.month())) {
                setValidDate(true)
            } else {
                setValidDate(false)
            }
            const DateValue = formatReportDate(newValue)
            setSelectedDate(newValue);
            handleChangePatientsFilter(newValue, "Date", DateValue)
        }
    };
    return (
        <div className={styles.BillingMonthFilter} data-testid="MonthFilter">
            <div className={styles.customMarginBottom}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        label="Month"
                        openTo="month"
                        views={['year', 'month']}
                        value={selectedDate}
                        onChange={handleDateChange}
                        minDate={threeYearsAgo}
                        maxDate={currentDate}
                        format="MMM YYYY"
                        slotProps={{
                            textField: { size: 'small' },
                            popper: {
                                popperOptions: {
                                    modifiers: [
                                        {
                                            name: 'applyCustom',
                                            enabled: true,
                                            phase: 'beforeWrite',
                                            requires: ['computeStyles'],
                                            fn: ({ state }) => {
                                                state.styles.popper.height = '358px';
                                                if (state.placement.includes('top-start')) {
                                                    state.styles.popper = {
                                                        ...state.styles.popper,
                                                        display: 'flex',
                                                        alignItems: 'flex-end',
                                                    };
                                                }
                                                if (state.placement.includes('bottom')) {
                                                    state.styles.popper = {
                                                        ...state.styles.popper,
                                                        display: 'block',
                                                    };
                                                }
                                            },
                                        },
                                    ],
                                }
                            },
                        }}
                        sx={{ width: '100%' }}
                    />
                </LocalizationProvider>
            </div>
        </div>
    );
}

export default MonthFilter;
